import { render, staticRenderFns } from "./black-list.vue?vue&type=template&id=1e6c4846&"
import script from "./black-list.vue?vue&type=script&lang=js&"
export * from "./black-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports